import Collections from '../components/home/Collections';
import FloorBounties from '../components/home/FloorBounties';
import HomeHeroSKClub from '../components/home/HomeHeroSKClub';
import UtilityInfo from '../components/home/UtilityInfo';
import ShittyStickersCta from '../components/ShittyStickersCta';
import TopUsersFeed from '../components/TopUsersFeed';

export default function Home() {
  return (
    <>
      <HomeHeroSKClub />
      <div className='bg-gray-800 flex flex-col gap-24 pt-24 pb-48'>
        <Collections />
        <FloorBounties />
        <ShittyStickersCta />
        <UtilityInfo />
        <div>
          <TopUsersFeed />
        </div>
      </div>
    </>
  );
}
